

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const UPDATEMANAGEREVALUATION= createAsyncThunk(
  "updateManagerEvaluation/updateManagerEvaluation",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const updateManagerEvaluationSlice = createSlice({
  name: "updateManagerEvaluationSlice",
  initialState: {
    updateManagerEvaluation: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfupdateManagerEvaluation: (state) => {
        state.updateManagerEvaluation.loading = false
        state.updateManagerEvaluation.error = false
        state.updateManagerEvaluation.data = []
        state.updateManagerEvaluation.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(UPDATEMANAGEREVALUATION.fulfilled, (state, action) => {
      state.updateManagerEvaluation = {
        ...state.updateManagerEvaluation,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATEMANAGEREVALUATION.pending, (state, action) => {
      state.updateManagerEvaluation = {
        ...state.updateManagerEvaluation,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATEMANAGEREVALUATION.rejected, (state, action) => {
      state.updateManagerEvaluation = {
        ...state.updateManagerEvaluation,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const updateManagerEvaluationAction = {
    UPDATEMANAGEREVALUATION,
};

export { updateManagerEvaluationAction };
export default updateManagerEvaluationSlice.reducer;
export const {setInitialStateOfupdateManagerEvaluation} = updateManagerEvaluationSlice.actions
